import React, { useEffect, useState } from "react";
import "./index.less";
import { Badge, Button, List } from "antd";
import { AvatarCom, AvatarComProps, RelationshipType } from "../../AvatarCom";
import { CloseOutlined } from "@ant-design/icons";
import { useChannelRoomStore, useFriendStore, useGlobalStore } from "@obsbot/remo-stores";
import { useParams } from "react-router-dom";
import { PrivateRightMenu } from "./PrivateRightMenu";
import { ListEmpty } from "../ContactList/ListEmpty";
import { BellDisabled, BlockBellIcon } from "../../SvgIconCom/ChatContentIcon";
import useWebSocketStore from "@obsbot/remo-stores/src/ws-store";
import EmptyPrivatePNG from "../icons/empty-private.png";
import { getBlockList } from "@obsbot/remo-server-api";
import MoreDangerSVG from "../icons/moreDanger.svg";
export interface UserProfile {
    profileCustomField: [];
    nick: string;
    userID: string;
    avatar: string;
    [param: string]: any;
}
export interface ContactItem extends AvatarComProps {
    userID: string;
    timestamp?: number;
    source?: string;
    remark?: string;
    profile?: UserProfile;
    lastMessageTime?: number;
    isLastMessageRead?: boolean;
    groupList?: [];
    friendCustomField?: [];
    addTime?: number;
    conversationID?: string;
    isPinned?: boolean;
    messageRemindType?: string;
    userProfile?: any;
    handleStatus?: number;
    newMessage: number;
    tempType?: string; // 判断是否为临时会话
}

export interface ContactListProps {
    contactList?: ContactItem[];
    // 对应私信、列表、申请等模式
    relationshipGroup?: RelationshipType;
    hasSelectedUser?: boolean;
    isSelectedClick?: () => void;
    onClick?: (key: string, item: AvatarComProps) => void; // 点击联系人时的回调函数
}
export const PrivateList: React.FC<ContactListProps> = ({
    contactList = [],
    hasSelectedUser = false, // 用于跟踪选中的用户
    relationshipGroup,
    isSelectedClick,
    onClick,
}) => {
    const params = useParams();
    const { userInfo } = useGlobalStore();
    const { conversation, conversationOnline, friendList, deleteConversation, rtm } =
        useFriendStore();
    const [curContactList, setCurContactList] = useState<ContactItem[]>(contactList);
    const [showContextMenu, setShowContextMenu] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<ContactItem | null>(null); // 用于跟踪选中的用户
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 }); // 菜单位置
    const { sendMessage, isConnected } = useWebSocketStore();
    const { updateBlockedUsers } = useChannelRoomStore();

    useEffect(() => {
        if (params.id) {
            const selected = curContactList.find(item => item.userID === params.id);
            if (selected) {
                setSelectedUser(selected);
            }
        }
    }, [params.id, curContactList]);

    useEffect(() => {
        if (params.id && isConnected) {
            sendMessage(
                JSON.stringify({
                    event: "emoji",
                    payload: {
                        senderId: userInfo?.user_id,
                        receiverId: params.id,
                        type: "C2C",
                    },
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id, isConnected]);

    useEffect(() => {
        getBlockList().then(res => {
            if (res.code === "200") {
                updateBlockedUsers(res.data || []);
            }
        });
    }, []);

    useEffect(() => {
        // 模拟数据 ， 如果需要
        const tempContactList: ContactItem[] = [];
        let tempLoopList: any[] = [];
        tempLoopList = conversation.conversationList.filter(e => e.type === "C2C");
        for (const item of tempLoopList) {
            const profile =
                friendList.find(e => e.userID === item.userProfile.userID)?.profile ||
                item.userProfile;
            const relationship = getRelationship(item?.groupList);
            const status = conversationOnline[profile.userID];
            tempContactList.push({
                userID: profile?.userID,
                userName: profile?.nick || profile.userID,
                avatar: profile?.avatar === "" ? undefined : profile.avatar,
                newMessage: item.unreadCount || 0,
                lastMessageTime: item?.lastMessage?.lastTime * 1000,
                isLastMessageRead: item?.lastMessage?.isPeerRead || true,
                size: 32,
                status: status === "invisible" ? "offline" : status,
                conversationID: item.conversationID,
                relationship: relationship,
                isPinned: item.isPinned,
                messageRemindType: item.messageRemindType,
            });
        }
        setCurContactList([...tempContactList]);
        if (!hasSelectedUser) {
            setSelectedUser(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasSelectedUser, conversation, friendList, relationshipGroup, conversationOnline]);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent): void => {
            const target = e.target as HTMLElement;
            // 如果点击的目标不在右键菜单内，则关闭菜单
            if (!target.closest(".private-right-menu-popover")) {
                setShowContextMenu(false);
            }
        };

        if (showContextMenu) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showContextMenu]);

    const getRelationship = (groupList: any[]): RelationshipType | undefined => {
        const relationshipTypes = ["lovers", "buddy", "bosom_friend"];
        let result: RelationshipType | undefined = undefined;
        groupList &&
            groupList.forEach((item: RelationshipType) => {
                if (relationshipTypes.includes(item)) {
                    result = item;
                }
            });
        return result;
    };

    const closeThisChat = async (item: ContactItem): Promise<any> => {
        if (item.tempType) {
            console.log("[WEB DEBUG]删除临时的会话列表");
        }
        if (item.conversationID && rtm && userInfo) {
            const isFriend = await rtm.checkFriend([userInfo.user_id, item.userID]);
            // 不是好友的话，关闭会话列表就清空聊天记录
            await deleteConversation(item.conversationID, !isFriend);
        }
    };

    const onMouseDownListItem = (item: ContactItem, e: React.MouseEvent<HTMLDivElement>): void => {
        e.stopPropagation(); // 阻止事件冒泡，防止点击按钮时触发 List.Item 的 onClick 事件
        e.preventDefault(); // 阻止浏览器的右键事件
        setSelectedUser(item);
        if (e.button === 2) {
            const menuHeight = item.userID === "administrator" ? 125 : 260; // 菜单预估高度
            const windowHeight = window.innerHeight;
            const yPos = e.clientY;
            // 如果点击位置距离窗口底部不足菜单高度，则向上显示
            const adjustedY = windowHeight - yPos < menuHeight ? yPos - menuHeight : yPos;
            setMenuPosition({ x: e.clientX + 20, y: adjustedY });
            setShowContextMenu(true);
        }
    };

    return (
        <div className="private-list">
            <List
                className="list-content"
                dataSource={curContactList}
                locale={{ emptyText: <ListEmpty emptyImg={EmptyPrivatePNG} modeType="private" /> }}
                renderItem={(item, index) => (
                    <List.Item
                        key={index}
                        className={`${selectedUser?.userID === item.userID ? "selected" : ""} ${item.isPinned ? "pinned" : ""}`}
                        onClick={() => {
                            setSelectedUser(item);
                            isSelectedClick && isSelectedClick();
                            onClick && onClick("TextChatPage", item);
                            if (showContextMenu) {
                                setShowContextMenu(false);
                            }
                        }}
                        onContextMenu={onMouseDownListItem.bind(this, item)}
                    >
                        <span className="avatar-in-list">
                            <Button
                                className="close-private-icon"
                                icon={
                                    <CloseOutlined
                                        onPointerMoveCapture={undefined}
                                        onPointerOverCapture={undefined}
                                    />
                                }
                                type="text"
                                onClick={e => {
                                    e.stopPropagation(); // 阻止事件冒泡，防止点击按钮时触发 List.Item 的 onClick 事件
                                    closeThisChat(item);
                                }}
                            ></Button>
                            <AvatarCom {...item} modeType="private" />
                        </span>
                        <Badge
                            className="private-notify-badge"
                            count={
                                item.newMessage >= 99 ? (
                                    <img src={MoreDangerSVG} />
                                ) : (
                                    item.newMessage
                                )
                            }
                            dot={item.messageRemindType === "AcceptNotNotify"}
                            overflowCount={99}
                            // text={item.newMessage >= 99 ? <MoreOutlined /> : undefined}
                        ></Badge>
                        {item.messageRemindType === "Discard" ? (
                            <BlockBellIcon className="bell-block" />
                        ) : null}
                        {item.messageRemindType === "AcceptNotNotify" ? (
                            <BellDisabled className="bell-disabled" />
                        ) : null}
                    </List.Item>
                )}
            />
            {selectedUser && rtm && (
                <PrivateRightMenu
                    conversation={selectedUser}
                    menuPosition={menuPosition}
                    open={showContextMenu}
                    rtm={rtm}
                    onClickMenu={show => setShowContextMenu(show)}
                />
            )}
        </div>
    );
};

export const getRelationType = (relationship?: string): number => {
    // 0-普通好友 1-情侣 2-闺蜜 3-兄弟
    switch (relationship) {
        case "lovers": {
            return 1;
        }
        case "bosom_friend": {
            return 2;
        }
        case "buddy": {
            return 3;
        }
        default: {
            return 0;
        }
    }
};
